import moment from "moment"

export default {
  "loginForm": {
    "username": "Số điện thoại hoặc Email",
    "password": "Mật khẩu",

    "usernamePlaceholder": "Số điện thoại với mã quốc gia hoặc Email",
    "passwordPlaceholder": "Mật khẩu",

    "phoneExample": "Ex: +62896123465659"
  },

  "passwordResetForm": {
    "email": "Email",

    "emailPlaceholder": "Nhập email của bạn"
  },

  "farmForm": {
    "farmTooltip": "Viết tên trang trại của bạn ở đây",
    "farmTooltip2": "Viết địa chỉ trang trại của bạn ở đây",
    "farmTooltip3": "Viết dữ liệu trang trại của bạn ở đây",
    
    "name": "Tên Trại Nuôi",
    "area": "Diện Tích (m²)",
    "countryId": "Quốc Gia",
    "regionId": "Thành Phố/Guận/Huyện",
    "currencyId": "Tiền Tệ",
    "timezone": "Múi Giờ",
    "provinceId": "Tỉnh",
    "regencyId": "Thành phố",
    "districtId": "Huyện",
    "villageId": "Huyện Phụ",
    "address": "Địa chỉ",

    "namePlaceholder": "Tên Trại Nuôi",
    "areaPlaceholder": "-",
    "countryIdPlaceholder": "Lựa Chọn",
    "regionIdPlaceholder": "Lựa Chọn",
    "currencyIdPlaceholder": "Lựa Chọn",
    "provinceIdPlaceholder": "Tỉnh Chọn",
    "regencyIdPlaceholder": "Thành phố Chọn",
    "districtIdPlaceholder": "Huyện Chọn",
    "villageIdPlaceholder": "Huyện Phụ Chọn",
    "addressPlaceholder": "Tên khối, tên đường, thông tin khác",
    "timezonePlaceholder": "Lựa Chọn",

    "deleteSubtitle": "Chu kỳ dữ liệu, ao và trang trại sẽ bị xóa và bạn không thể truy cập lại.",
    "createFarm": "Tạo Trại nuôi"
  },

  "pondForm": {
    "farmId": "Trại nuôi",
    "title": "Tạo ao cho",
    "totalPonds": "Tổng Số Ao",
    "namePrefix": "Tên Ao Chung",
    "name": "Tên Ao",
    "type": "Loại Ao",
    "length": "Chiều Dài (m)",
    "width": "Chiều Rộng (m)",
    "area": "Diện Tích (m²)",
    "deep": "Độ Sâu (m)",
    "diameter": "Đường Kính Ao (m)",

    "farmIdPlaceholder": "-",
    "totalPondsPlaceholder": " ",
    "namePrefixPlaceholder": " ",
    "namePlaceholder": " ",
    "typePlaceholder": " ",
    "lengthPlaceholder": " ",
    "widthPlaceholder": " ",
    "areaPlaceholder": " ",
    "deepPlaceholder": " ",

    "namePrefixHelper": "Số thứ tự của ao sẽ được tự động sắp xếp theo tổng số ao",

    "totalPondsMaxMessage": "Bạn có thể tạo tối đa %{max} ao với phiên bản miễn phí. Vui lòng sử dụng ứng dụng trên website nếu muốn tạo thêm.",

    "pond": "Ao Nuôi",
    "formTitle": "Danh Sách Ao Nuôi",
    "formSubtitle": "Thay đổi diện tích ao theo kích cở thực tế để việc tính toán ước lượng phù hợp hơn"
  },

  "cycleForm": {
    "id": "Một chu kỳ",
    "farmId": "Trại nuôi",
    "pondId": "Ao nuôi",
    "totalSeed": "Tổng số hạt giống (cái đuôi)",
    "totalSeedType": "Tổng số loại hạt giống",
    "startedAt": "Bắt đầu lúc",
    "finishedAt": "Hoàn thành lúc",
    "initialAge": "Tuổi ban đầu (ngày)",
    "preparationDay": "Ngày chuẩn bị (ngày)",
    "hatcheryId": "ấp trứng",
    "speciesId": "Loài",
    "broodStockProductId": "Broodstock",
    "feedingTrayCount": "Tổng số khay nạp",
    "limitWeightPerArea": "Mang năng lực (kg/m²)",
    "targetCultivationDay": "Trồng trọt mục tiêu cũ (ngày)",
    "targetSize": "Đếm mục tiêu",
    "targetSurvivalRate": "Mục tiêu SR (%)",
    "survivalRatePredictionMethod": "Phương pháp dự đoán SR",
    "remark": "ghi chú (Không bắt buộc)",
    "remarkPlaceholder": "ghi chú",
    "minimumFr": "Bảng Fr chưa hoàn thành. Hoàn thành bảng Fr cho đến 60 tại đây",
    "warning": "Cảnh báo! thay đổi ngày thả giống sẽ thay đổi số ngày tuổi của tôm (DoC) và có thể ảnh hưởng đến kết quả ước tính",
    "cycleTooltip": "Viết ra chu kỳ ở đây",

    "idPlaceholder": "Chọn chu kỳ",
    "farmIdPlaceholder": "Chọn trang trại",
    "pondIdPlaceholder": "Chọn ao",
    "totalSeedPlaceholder": "Tổng số tôm giống",
    "totalSeedTypePlaceholder": "Tổng số loại hạt giống",
    "startedAtPlaceholder": "Bắt đầu lúc",
    "finishedAtPlaceholder": "Hoàn thành lúc",
    "initialAgePlaceholder": "Không bắt buộc",
    "preparationDayPlaceholder": "Không bắt buộc",
    "hatcheryIdPlaceholder": "Chọn trại giống",
    "speciesIdPlaceholder": "Chọn loài",
    "broodStockProductIdPlaceholder": "Broodstock",
    "feedingTrayCountPlaceholder": "Nhá/Sàng ăn",
    "limitWeightPerAreaPlaceholder": " ",
    "targetCultivationDayPlaceholder": " ",
    "targetSizePlaceholder": " ",
    "targetSurvivalRatePlaceholder": " ",
    "area": "Area (m²)",
    "areaPlaceholder": " ",
    "deep": "Depth (m)",
    "deepPlaceholder": " ",
    "survivalRatePredictionMethodPlaceholder": "Chọn phương pháp dự đoán SR",

    "initialAgeHelper": "Tuổi ban đầu lúc bắt đầu",
    "targetSizeHelper": "DoC 100",

    "cycleClose": "Kết thúc chu kỳ",
    "targetAndCycles": "Mục tiêu chu kỳ và thông tin",
    "targetSubtitle": "Điền thông tin vào biểu mẫu này dựa theo kế hoạch của bạn để đảm bảo việc tính toán và dự báo của Jala là chính xác",
    "nextPond": "Ao tiếp theo",

    "net": "Net (Tổng số giống bạn đã đặt hàng)",
    "gross": "Gross (Tổng số giống nhận được từ trại giống)",
    "actual": "Thực tế (Tổng số giống thực tế nhận)",
    "netNote": "Tổng số giống bạn đã đặt hàng",
    "grossNote": "Tổng số giống nhận được từ trại giống",
    "actualNote": "Tổng số giống thực tế nhận",

    "fr": "Tỷ lệ nguồn cấp dữ liệu",
    "fixed": "đã sửa",
    "ai": "Theo phép đo",
    "customFr": "Bảng FR tùy chỉnh",
    "stpFr": "Bảng FR STP",
    "adg": "ADG",
    "aiCultivation": "Tỷ lệ thức ăn, khay ăn, tỷ lệ chết",

    "cycle": "Đi xe đạp",
    "createCycle": "Tạo chu kỳ",
    "updateCycle": "Tiết kiệm",

    "pond": "Ao",
    "pondPlaceholder": "Chọn ao",
    "seed": "Tổng số hạt giống (miếng)",
    "seedPlaceholder": "Tổng số hạt giống",
    "type": "loại",
    "typePlaceholder": "Lựa chọn...",
    "hatchery": "ấp trứng",
    "hatcheryPlaceholder": "Lựa chọn...",
    "spread": "Ngày lây lan",
    "spreadPlaceholder": "Lựa chọn...",
    "species": "Species",
    "speciesPlaceholder": "Lựa chọn...",
    "tray": "Tổng số khay nạp",
    "trayPlaceholder": "Cái mâm",
    "biomass": "Mang năng lực (kg/m²)",
    "biomassPlaceholder": "sinh khối",
    "targetDay": "Mục tiêu canh tác (ngày)",
    "targetDayPlaceholder": "Mục tiêu canh tác",
    "targetSr": "SR Mục tiêu (%)",
    "notes": "ghi chú",
    "notesPlaceholder": "ghi chú",

    "feedPrice": "Giá thức ăn (để ước tính chi phí sản xuất)",
    "feedPricePlaceholder": "Giá thức ăn",
  },

  "farmShrimpPriceForm": {
    "farmId": "Trại nuôi",
    "shrimpPriceId": "Chọn vị trí và giá cả",
    "shrimpPriceIdPrivate": "Chọn vị trí và tham khảo giá (không bắt buộc)",
    "shrimpPriceSubtitle": "Bạn có thể chọn một vị trí giá tham chiếu hoặc tạo giá cá nhân của riêng bạn",

    "farmIdPlaceholder": "Chọn trang trại",
    "shrimpPriceIdPlaceholder": "Chọn vị trí và giá cả",
    "shrimpPriceIdPrivatePlaceholder": "Chọn tham khảo vị trí và giá",

    "title": "Định giá vụ thu hoạch của bạn với giá tôm thực tế",
    "subtitle": "Kết nối giá tôm gần nhất với trại nuôi của bạn. Jala sẽ tính toán giá bán tôm của bạn dựa trên sản lượng ước tính với giá tôm đã chọn.",
    "helperText": "*Giá 100 con/kg kể từ ngày bắt đầu chu kỳ gần nhất: %{date}",
    "privateHelperText": "*Giá tôm tư nhân cập nhật lần cuối bởi: %{user} tại : %{date}",

    "source": "Nguồn giá bán",
    "newest": "Giá tôm mới nhất",
    "private": "Giá Tôm Riêng",
    "createNew": "Tạo mới",

    "privateFormTitle": "Tạo Giá Tôm Riêng",
    "location": "Vị trí trang trại",
    "locationPlaceholder": "vị trí đầu vào",
    "currency": "Tiền tệ",
    "delete": "Xóa Giá Tôm Riêng?",
    "info": "Bạn có thể để trống biểu mẫu nếu bạn không có giá, giá tôm riêng được lưu sẽ không xuất hiện trên trang giá tôm công khai.",

    "createPrivateTitle": "Kết nối sinh khối ước tính với giá tôm",
    "createPrivateSubtitle": "Jala sẽ tính giá bán tôm của bạn dựa trên sinh khối ước tính với giá của loại tôm đã chọn.",
    "size100Validation": "kích thước 100 là bắt buộc để điền vào",

    "deleteModalTitle": "Xoá giá tôm riêng",
    "deleteModalSubtitle": "Bạn có chắc chắn xóa dữ liệu?",
    "emptyPrivatePriceTitle": "Giá tôm riêng chưa có",
    "emptyPrivatePriceSubtitle": "Bạn có thể tạo bảng giá tôm riêng để nâng cao độ chính xác của giá bán ước tính",
    "dropdownPrivateTitle": "Chọn Giá Tôm Riêng",
    "sizeInput": "Giá cả và kích thước",
    "createdBy": "Được tạo bởi: {{user}}",

    "privateShrimpPriceSaveTitle": "Tiết kiệm giá riêng?",
    "privateShrimpPriceSaveSubtitle": "Bạn có chắc chắn muốn tiết kiệm giá tôm tư nhân?",
    "newestShrimpPriceSaveTitle": "Lưu giá mới nhất?",
    "newestShrimpPriceSaveSubtitle": "Bạn có chắc chắn muốn lưu giá tôm mới nhất?",
  },

  "waterQualityMultiMeasurementForm": {
    "farmId": "Trại nuôi",
    "batchId": "Lô hàng",
    "pondId": "Ao nuôi",
    "cycleId": "Ao nuôi",
    "measuredDate": "Ngày đo",
    "measuredTime": "Thời gian đo lường",
    "temperature": "Nhiệt độ (°C)",
    "ph": "pH",
    "salinity": "Độ mặn (ppt)",
    "do": "DO (mg/L)",
    "transparency": "Độ trong (cm)",
    "waterLevel": "Mức nước (cm)",
    "doPercent": "DO phần trăm (%)",
    "turbidity": "Độ đục (NTU)",
    "ec": "Độ dẫn điện (µS)",
    "color": "Màu nước",
    "weather": "Thời tiết",
    "measurementTooltip": "Ghi lại số đo ở đây",
    "orp": "ORP (mV)",

    "farmIdPlaceholder": "Chọn trang trại",
    "batchIdPlaceholder": "Chọn Lô hàng",
    "pondIdPlaceholder": "Chọn ao",
    "cycleIdPlaceholder": "Chọn ao",
    "measuredDatePlaceholder": "Ngày đo",
    "measuredTimePlaceholder": "Thời gian đo lường",
    "temperaturePlaceholder": "-",
    "phPlaceholder": "-",
    "salinityPlaceholder": "-",
    "doPlaceholder": "-",
    "transparencyPlaceholder": "-",
    "waterLevelPlaceholder": "-",
    "doPercentPlaceholder": "-",
    "turbidityPlaceholder": "-",
    "ecPlaceholder": "-",
    "colorPlaceholder": "Chọn màu",
    "weatherPlaceholder": "Chọn thời tiết",
    "orpPlaceholder": "-",

    "waterQualityMultiMeasurement": "Chất lượng nước",
    "otherParameters": "Các thông số khác",
  },
  "feedForm": {
    "farmId": "Trại nuôi",
    "cycleId": "Ao nuôi",
    "loggedDate": "Ngày",
    "loggedTime": "Ngày",
    "stockId": "Các mặt hàng",
    "quantity": "Lượng thức ăn (kg)",
    "fasting": "Nhịn ăn",
    "remark": "Ghi chú (Tùy chọn)",
    "feedTooltip": "Ghi lại dữ liệu Nguồn cấp dữ liệu bạn cung cấp tại đây",

    "farmIdPlaceholder": "Chọn trang trại",
    "cycleIdPlaceholder": "Chọn ao",
    "loggedDatePlaceholder": "Ngày nguồn cấp dữ liệu",
    "loggedTimePlaceholder": "Thời gian cho ăn",
    "stockIdPlaceholder": "Chọn Các mặt hàng",
    "quantityPlaceholder": " ",
    "remarkPlaceholder": "Ghi chú",

    "feeding": "cho ăn"
  },
  "feedingTrayControlForm": {
    "farmId": "Trại nuôi",
    "cycleId": "Ao nuôi",
    "loggedDate": "Ngày",
    "loggedTime": "Kiểm tra thời gian",
    "feedLoggedAt": "Giờ cho ăn",
    "datePlaceholder": "Ngày",
    "remark": "Ghi chú (Tùy chọn)",
    "trayTooltip": "Ghi vào khay dữ liệu đã kiểm tra tại đây",
    "remainFeed": "Chọn nguồn cấp dữ liệu còn lại trên khay",

    "feedingTray": "Nhá/Sàng %{number}",

    "farmIdPlaceholder":"Chọn trang trại",
    "cycleIdPlaceholder": "Chọn Ao nuôi",
    "loggedDatePlaceholder": "Chọn ngày",
    "loggedTimePlaceholder": "Chọn thời gian",
    "feedLoggedAtPlaceholder": "Chọn Giờ cho ăn",
    "remarkPlaceholder": "Ghi chú",
    "feedingTrayControlRemark": "*Thức ăn thừa trong khay:",

    "feedingTrayControl": "Nhá/Sàng ăn"
  },
  "samplingForm": {
    "farmId": "Trại nuôi",
    "cycleId": "Ao nuôi",
    "sampledAt": "Ngày",
    "averageWeight": "trọng lượng (g)",
    "files": "Hình ảnh",
    "remark": "Ghi chú (Tùy chọn)",
    "sampleTooltip": "Ghi lại dữ liệu lấy mẫu tại đây",

    "farmIdPlaceholder":"Chọn trang trại",
    "cycleIdPlaceholder": "Chọn ao",
    "sampledAtPlaceholder": "Ngày lấy mẫu",
    "averageWeightPlaceholder": " ",
    "filesPlaceholder": "Hình ảnh",
    "remarkPlaceholder": "Ghi chú",

    "sampling": "Lấy mẫu"
  },
  "treatmentForm": {
    "farmId": "Trại nuôi",
    "pondId": "Ao nuôi",
    "cycleId": "Ao nuôi",
    "stockId": "Các mặt hàng",
    "name": "Phòng, trị bệnh",
    "treatedAt": "Ngày",
    "quantity": "Số lượng",
    "remark": "Ghi chú (Tùy chọn)",
    "treatmentTooltip": "Ghi lại dữ liệu xử lý trên mỗi ao",

    "farmIdPlaceholder":"Chọn trang trại",
    "pondIdPlaceholder": "Chọn ao",
    "cycleIdPlaceholder": "Chọn ao",
    "stockIdPlaceholder": "Chọn Các mặt hàng",
    "namePlaceholder": "Phòng, trị bệnh",
    "treatedAtPlaceholder": "Chọn ngày",
    "quantityPlaceholder": " ",
    "remarkPlaceholder": "Ghi chú",

    "treatment": "Phòng, trị bệnh",

    "recordType": "Loại bản ghi",
    "radioBasic": "Ghi chú văn bản",
    "radioPro": "Sản phẩm xử lý được sử dụng",
  },
  "harvestForm": {
    "farmId": "Trại nuôi",
    "cycleId": "Ao nuôi",
    "harvestedAt": "Ngày",
    "status": "Loại thu hoạch",
    "weight": "Tổng khối lượng (kg)",
    "size": "Kích cở (cái đuôi/kg)",
    "price": "Giá mỗi kg",
    "sellingPrice": "Tổng giá",
    "buyer": "Người mua (Không bắt buộc)",
    "remark": "Ghi chú (Tùy chọn)",
    "harvestTooltip": "Ghi lại dữ liệu Thu hoạch tại đây. Bạn có thể chọn loại thu hoạch một phần, toàn bộ hoặc thất bại",

    "farmIdPlaceholder":"Chọn trang trại",
    "cycleIdPlaceholder": "Chọn ao",
    "harvestedAtPlaceholder": "Ngày thu hoạch",
    "statusPlaceholder": "Chọn Loại thu hoạch",
    "weightPlaceholder": " ",
    "sizePlaceholder": " ",
    "pricePlaceholder": " ",
    "buyerPlaceholder": "Người mua",
    "remarkPlaceholder": "Ghi chú",

    "full": "Đầy",
    "partial": "Một phần",
    "failed": "Không thành công",
    "harvest": "Mùa gặt",
  },
  "mortalityForm": {
    "farmId": "Trại nuôi",
    "cycleId": "Ao nuôi",
    "recordedAt": "Ngày",
    "totalWeight": "Tổng trọng lượng (kg)",
    "size": "đếm (cái đuôi/kg)",
    "multiplier": "Số nhân",
    "quantityFinal": "Tổng số người chết (đuôi)",
    "multiplierInfo": "Dự đoán khả năng tôm chết không rõ nguồn gốc.",
    "files": "Hình ảnh",
    "remark": "Ghi chú (Tùy chọn)",
    "mortalityTooltip": "Ghi lại dữ liệu tử vong ở đây",
    "quantityPlaceholder": "0",

    "farmIdPlaceholder": "Chọn trang trại",
    "cycleIdPlaceholder": "Chọn ao",
    "recordedAtPlaceholder": "Chọn ngày",
    "totalWeightPlaceholder": "0",
    "sizePlaceholder": "0",
    "multiplierPlaceholder": "E.g. 1.5",
    "filesPlaceholder": "Hình ảnh",
    "remarkPlaceholder": "Ghi chú",

    "mortality": "Số lượng chết",

    "averageWeight": "trọng lượng (g)",
    "quantity": "Tổng số lượng (ước tính)",
    "basedOn": "Dựa trên",
    "basedOnQuantity": "Số lượng (cái)",
    "basedOnSize": "Kích cỡ"
  },
  "chemicalMultiMeasurementForm": {
    "farmId": "Trại nuôi",
    "batchId": "Lô hàng",
    "pondId": "Ao nuôi",
    "cycleId": "Ao nuôi",
    "measuredDate": "Ngày đo",
    "measuredTime": "Thời gian đo lường",
    "chemicalTooltip": "Ghi lại dữ liệu hóa học ở đây",

    "ammonia": "Amoniac (NH3) (ppm)",
    "nitrat": "Nitrat (NO3) (ppm)",
    "nitrit": "Nitrit (NO2) (ppm)",
    "alkalinity": "Độ kiềm (ppm)",
    "hardness": "độ cứng (ppm)",
    "calcium": "Canxi (Ca) (ppm)",
    "magnesium": "Magiê (Mg) (ppm)",
    "carbonat": "Cacbonat (CO3) (ppm)",
    "bicarbonat": "Carbonat axit (HCO3) (ppm)",
    "tom": "Tổng lượng chất hữu cơ (TOM) (ppm)",
    "orp": "Khả năng giảm oxy hóa (ORP) (mV)",
    "ammonium": "Amonium (NH4) (ppm)",
    "phosphate": "Phospho (PO4) (ppm)",
    "totalAmmonia": "Tổng Amoniac (ppm)",
    "potassium": "Kali (ppm)",

    "farmIdPlaceholder": "Chọn trang trại",
    "batchIdPlaceholder": "Chọn Lô hàng",
    "pondIdPlaceholder": "Chọn ao",
    "cycleIdPlaceholder": "Chọn ao",
    "measuredDatePlaceholder": "Ngày đo",
    "measuredTimePlaceholder": "Thời gian đo lường",

    "ammoniaPlaceholder": "-",
    "nitratPlaceholder": "-",
    "nitritPlaceholder": "-",
    "alkalinityPlaceholder": "-",
    "hardnessPlaceholder": "-",
    "calciumPlaceholder": "-",
    "magnesiumPlaceholder": "-",
    "carbonatPlaceholder": "-",
    "bicarbonatPlaceholder": "-",
    "tomPlaceholder": "-",
    "orpPlaceholder": "-",
    "ammoniumPlaceholder": "-",
    "phosphatePlaceholder": "-",
    "totalAmmoniaPlaceholder": "-",
    "potassiumPlaceholder": "-",

    "chemical": "Hóa học"
  },
  "planktonMultiMeasurementForm": {
    "farmId": "Trại nuôi",
    "batchId": "Lô hàng",
    "pondId": "Ao nuôi",
    "cycleId": "Ao nuôi",
    "measuredDate": "Ngày đo",
    "measuredTime": "Thời gian đo lường",
    "planktonTooltip": "Ghi lại dữ liệu sinh vật phù du ở đây",

    "totalPlankton": "Tổng số sinh vật phù du (Total) (cell/ml)",
    "ga": "Gren Algae (GA) (cell/ml)",
    "bga": "Blue Green Algae (BGA) (cell/ml)",
    "dino": "Dinoflagellata (DINO) (cell/ml)",
    "diatom": "Diatom (cell/ml)",
    "prozoo": "Protozoa (PRO) (cell/ml)",
    "floc": "Floc (ml)",
    "gba": "Golden Brown Algae (GBA) (cell/ml)",
    "euglenophyta": "Euglenophyta (cell/ml)",
    "zoo": "Zoo (ZOO) (cell/ml)",
    "haptyophyta": "Haptyophyta (cell/ml)",
    "gga": "Golden Green Algae (GGA) (cell/ml)",
    "yga": "Yellow Green Algae (YGA) (cell/ml)",

    "farmIdPlaceholder": "Chọn trang trại",
    "batchIdPlaceholder": "Chọn Lô hàng",
    "pondIdPlaceholder": "Chọn ao",
    "cycleIdPlaceholder": "Chọn ao",
    "measuredDatePlaceholder": "Ngày đo",
    "measuredTimePlaceholder": "Thời gian đo lường",

    "totalPlanktonPlaceholder": "-",
    "gaPlaceholder": "-",
    "bgaPlaceholder": "-",
    "dinoPlaceholder": "-",
    "diatomPlaceholder": "-",
    "prozooPlaceholder": "-",
    "flocPlaceholder": "-",
    "gbaPlaceholder": "-",
    "euglenophytaPlaceholder": "-",
    "zooPlaceholder": "-",
    "haptyophytaPlaceholder": "-",
    "ggaPlaceholder": "-",
    "ygaPlaceholder": "-",

    "plankton": "Sinh vật phù du"
  },
  "microbiologyMultiMeasurementForm": {
    "farmId": "Trại nuôi",
    "batchId": "Lô hàng",
    "pondId": "Ao nuôi",
    "cycleId": "Ao nuôi",
    "measuredDate": "Ngày đo",
    "measuredTime": "Thời gian đo lường",
    "microbiologyTooltip": "Ghi lại dữ liệu vi sinh tại đây",

    "totalBacteria": "Tổng số vi khuẩn (CFU/ml)",
    "totalVibrio": "Tổng số Vibrio (CFU/ml)",
    "yellow": "Vibrio vàng (CFU/ml)",
    "green": "Vibrio xanh (CFU/ml)",
    "black": "Màu đen (CFU/ml)",
    "luminance": "Độ chói (CFU/ml)",

    "farmIdPlaceholder": "Chọn trang trại",
    "batchIdPlaceholder": "Chọn Lô hàng",
    "pondIdPlaceholder": "Chọn ao",
    "cycleIdPlaceholder": "Chọn ao",
    "measuredDatePlaceholder": "Ngày đo",
    "measuredTimePlaceholder": "Thời gian đo lường",

    "totalBacteriaPlaceholder": "-",
    "totalVibrioPlaceholder": "-",
    "yellowPlaceholder": "-",
    "greenPlaceholder": "-",
    "blackPlaceholder": "-",
    "luminancePlaceholder": "-",

    "microbiology": "Vi sinh vật"
  },
  "cycleDiseaseForm" : {
    "farmId": "Trại nuôi",
    "cycleId": "Ao nuôi",
    "loggedDate": "Ngày",
    "diseaseId": "Tên bệnh",
    "otherDisease": "Các tên bệnh khác",
    "files": "Hình ảnh",
    "remark": "Ghi chú (Tùy chọn)",
    "diseaseTooltip": "Ghi kết quả xét nghiệm bệnh tại đây",
    "diseaseEvidence": "Tải ảnh tôm nhiễm bệnh lên làm ghi chú bổ sung",

    "farmIdPlaceholder": "Chọn trang trại",
    "cycleIdPlaceholder": "Chọn ao",
    "loggedDatePlaceholder": "Ngày",
    "diseaseIdPlaceholder": "Chọn bệnh",
    "otherDiseasePlaceholder": "Bệnh khác",
    "filesPlaceholder": "Hình ảnh",
    "remarkPlaceholder": "Ghi chú",

    "cycleDisease": "Bệnh"
  },

  "simulationForm": {
    "name": "Tên mô phỏng",
    "area": "Trang trại rộng (m²)",
    "date": "Ngày",
    "seed": "Tổng số hạt giống",
    "periode": "Thời kỳ thu hoạch",
    "biomass": "Sinh khối tối đa (kg/m²)",
    "survival": "Tỷ lệ sống (%)",
    "size": "SIze ở ngày thứ 100 (tail/kg)",
    "feed": "Giá thức ăn cho mỗi kg",
    "shouldBeFilled": "Điền thông tin là bắt buộc",
    "shouldBeGreaterThan": "Phải lớn hơn {{value}}",
    "shouldBeLessThan": "Phải nhỏ hơn {{value}}",
    "age": "Tuổi đầu vào",
    "percent": "Phần trăm đầu vào",
    "namePlaceholder": `Simulation ${moment().format('YYYY-MM-DD')}`,
    "areaPlaceholder": "1.000 m²",
    "datePlaceholder": "Chọn ngày",
    "seedPlaceholder": "100.000 tails",
    "perioderPlaceholder": "120 days",
    "biomassPlaceholder": "1.2 kg/m²",
    "survivalPlaceholder": "100%",
    "sizePlaceholder": "45",
    "feedPlaceholder": "Rp 15.000",
    "agePlaceholder": "Tuổi đầu vào",
    "percentPlaceholder": "Phần trăm đầu vào"
  },

  "autoFeederDailyFeedForm": {
    "title": "Thêm Dữ Liệu Cho Ấu Trùng Asto",
    "subtitle": "Chi Tiết Việc Cung Cấp Thức Ăn",
    "start": "Bắt Đầu",
    "end": "Kết Thúc",
    "quantity": "Thức Ăn",
    "quantitycontinuous": "Tổng Lượng Thức Ăn Hằng Ngày",
    "remark": "ghi chú (Không bắt buộc)",
    "disclaimer": "Dữ liệu cung cấp thức ăn được thêm vào Asto sẽ được liên kết với dữ liệu canh tác trong JALA",

    "remarkPlaceholder": "#AutoFeeder",
    "ratio" : "Tỷ lệ nuôi cấy"
  }
}
